export default __webpack_public_path__ + "static/logo-bw-234f8bbd26bc1d842ecc8f7670e4744b.png";